/** @jsxImportSource @emotion/react */

import {
  CalciteAction,
  CalciteMenu,
  CalciteMenuItem,
  CalciteNavigation,
} from "@esri/calcite-components-react";
import "@esri/calcite-components/dist/components/calcite-navigation";
import "@esri/calcite-components/dist/components/calcite-navigation-user";
import { UserContext } from "context/UserContext";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import tw from "twin.macro";
import { HeaderProps } from "./Header.d";
import UserMenu from "./UserMenu";

const Header: React.FC<HeaderProps> = ({
  label,
  title,
  onActionSelect,
  parentRoute,
  breadCrumb,
}) => {
  const { hideNav } = useContext(UserContext);
  const navigate = useNavigate();
  return (
    <>
      <div css={[tw`z-10 sticky relative`]}>
        <CalciteNavigation slot="panel-top" label={label}>
          <CalciteAction
            scale="l"
            slot="navigation-action"
            text="Open"
            icon={hideNav ? "hamburger" : "x"}
            textEnabled={false}
            onClick={onActionSelect}
            css={[tw`lg:hidden block`]}
          ></CalciteAction>
          <CalciteNavigation slot="content-start">
            <CalciteMenu slot="content-start" label={label}>
              <CalciteMenuItem
                css={[tw`font-semibold`]}
                text={label}
                label={label}
                onClick={
                  breadCrumb
                    ? () => navigate(parentRoute ? parentRoute : "")
                    : undefined
                }
                breadcrumb={breadCrumb?.active ? true : undefined}
                active={undefined}
              ></CalciteMenuItem>
              {breadCrumb && breadCrumb.active && (
                <CalciteMenuItem
                  active={breadCrumb.active}
                  label={breadCrumb.title}
                  text={breadCrumb.title}
                  id={breadCrumb.id}
                ></CalciteMenuItem>
              )}
            </CalciteMenu>
          </CalciteNavigation>
          <UserMenu />
        </CalciteNavigation>
      </div>
    </>
  );
};

export default Header;
